"use client";

import { useEffect, useState } from "react";

const STORAGE_KEY = "dining-mate:remembered-guest-info";

export type RememberedGuestInfo = {
    fullName: string;
    phoneNumber: string;
    email: string;
};

export const useRememberedGuestInfo = () => {
    const [rememberedInfo, setRememberedInfo] = useState<RememberedGuestInfo | null>(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                const parsed = JSON.parse(stored) as Partial<RememberedGuestInfo>;
                if (
                    typeof parsed.fullName === "string" &&
                    typeof parsed.phoneNumber === "string" &&
                    typeof parsed.email === "string"
                ) {
                    setRememberedInfo(parsed as RememberedGuestInfo);
                }
            }
        } catch {
            // localStorage not available (e.g., private browsing) or corrupt JSON
        }
        setIsLoaded(true);
    }, []);

    const saveRememberedInfo = (info: RememberedGuestInfo) => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(info));
        } catch {
            // localStorage not available
        }
        setRememberedInfo(info);
    };

    const clearRememberedInfo = () => {
        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch {
            // localStorage not available
        }
        setRememberedInfo(null);
    };

    return { rememberedInfo, isLoaded, saveRememberedInfo, clearRememberedInfo };
};
